import { FC } from "react";

interface HandWalletMoneyProps {
  className?: string;
}

export const HandWalletMoney: FC<HandWalletMoneyProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="33" cy="33" r="29.04" fill="#DCEDFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.8317 18.9745C51.7349 20.7569 51.0941 22.9395 49.4051 23.9268L49.2696 24.0022C47.8197 24.7696 46.6535 28.7864 47.9105 32.7175C47.9692 32.8079 48.0264 32.899 48.0822 32.9907L48.2457 33.2677C48.2723 33.3143 48.2985 33.3609 48.3245 33.4078L48.4771 33.6909L48.6235 33.9782L48.7647 34.2695L48.9014 34.5651L49.1001 35.0164L49.2937 35.4775L49.6129 36.2679L50.0754 37.422L50.2872 37.9341L50.5115 38.4569L50.6693 38.8115L50.8348 39.171L51.0088 39.5354C51.0386 39.5965 51.0687 39.6579 51.0993 39.7194L51.2877 40.0913C51.32 40.1537 51.3527 40.2163 51.3859 40.2792L51.5907 40.6587C51.6258 40.7223 51.6614 40.7862 51.6975 40.8503L51.9206 41.2375L52.157 41.63C52.3597 41.9592 52.5772 42.2938 52.8117 42.6341L53.1013 43.0452C54.393 44.8381 55.2541 45.934 57.8291 48.051C53.9383 54.5321 47.6798 58.9006 41.4679 60.7664C37.1307 55.1003 30.7167 49.9033 24.1461 47.6883C19.8319 46.6092 15.011 46.4239 11.1018 46.72L10.4409 46.7754C8.92075 46.9152 7.55948 47.1284 6.44786 47.3883C4.77213 47.7805 3.10257 46.7094 2.71903 44.9968C2.3476 43.3382 3.31843 41.6856 4.90226 41.2271C3.84586 40.9206 2.98144 40.0492 2.71903 38.8773C2.33549 37.1648 3.38316 35.4585 5.0591 35.0665C5.5218 34.9583 6.04851 34.8581 6.63037 34.7679L6.62186 34.7311C6.23832 33.0183 7.286 31.312 8.96193 30.9203C9.45445 30.8051 10.02 30.6959 10.648 30.5961C10.5977 29.1036 11.5869 27.7365 13.0644 27.3911L13.5186 27.29L13.8566 27.2203L14.2218 27.1493L14.8181 27.0414L15.2467 26.9693L15.6989 26.8974L16.1739 26.8264L16.6707 26.7566L17.1882 26.6886L17.7255 26.6228L18.5666 26.5293L19.1493 26.471L19.7484 26.4166L20.363 26.3665L20.9922 26.3212L21.6348 26.2811L22.2901 26.2467L22.9569 26.2185C23.181 26.2102 23.4069 26.2029 23.6344 26.1969L24.3216 26.1825C24.4369 26.1807 24.5525 26.1792 24.6685 26.178L25.3684 26.1751C27.0104 26.1778 28.7117 26.248 30.4171 26.4125C30.6451 26.1142 30.8352 25.9163 30.979 25.8391L31.7418 25.9639L32.6063 26.118L33.3812 26.2652L34.2654 26.4433L35.0386 26.608L35.6505 26.7444L36.0714 26.8414L36.7191 26.9961L37.1599 27.1054L37.6066 27.2196L38.2849 27.3999L38.7408 27.5262L39.1983 27.6574L39.6561 27.7934L40.113 27.9342C40.1729 27.0741 40.2934 26.2234 40.4749 25.392C41.2923 21.6476 43.2234 18.8016 45.9122 17.3782C47.7025 16.4305 49.9046 17.1453 50.8317 18.9745Z"
        fill="#FFC8E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.141 33.5461L18.8879 33.5747C19.1392 33.586 19.3926 33.5992 19.6483 33.6143L20.4215 33.6653C21.9807 33.779 23.6145 33.9637 25.3051 34.234C25.4223 34.2527 25.5025 34.3648 25.484 34.4845C25.4656 34.6041 25.355 34.6869 25.2389 34.6674C23.0038 34.3102 20.8697 34.1034 18.8785 34.013L18.1385 33.9845C17.5276 33.9652 16.9312 33.9568 16.3505 33.9583L15.6613 33.9648C14.9798 33.976 14.3217 34.0008 13.6892 34.0374L13.0653 34.0779L12.459 34.1259L11.8707 34.1811C11.1952 34.2494 10.5574 34.3314 9.96105 34.4242L9.33807 34.5277L8.74769 34.6386L8.52089 34.6849L8.08364 34.7806C7.79949 34.8456 7.53015 34.9131 7.27629 34.9826C7.25761 34.9876 7.23893 34.99 7.22046 34.99C7.1258 34.99 7.03899 34.9253 7.01309 34.8273C6.98274 34.7101 7.05066 34.5897 7.16507 34.5585L7.5621 34.4547L7.98202 34.3541L8.20041 34.3052L8.65373 34.2105L9.12871 34.12L9.62483 34.0343C10.0469 33.965 10.4906 33.901 10.9544 33.8434L11.5206 33.7775L11.8109 33.747L12.4053 33.691C12.5059 33.6823 12.6072 33.6739 12.7093 33.6657L13.3308 33.6207L13.6481 33.6011L14.2955 33.5679L14.9596 33.5431L15.6399 33.5271C16.4428 33.5137 17.2777 33.5191 18.141 33.5461ZM22.6021 29.5373L23.3558 29.5713L24.1226 29.6166C25.7981 29.727 27.5629 29.9194 29.3943 30.2122C29.5114 30.2308 29.5917 30.343 29.5732 30.4627C29.5547 30.5824 29.4442 30.6653 29.3281 30.6456C27.0929 30.2883 24.9587 30.0815 22.9674 29.9911L22.2275 29.9625C21.3722 29.9355 20.5453 29.9299 19.7502 29.9428L19.0766 29.9584C18.6328 29.9718 18.1998 29.991 17.7781 30.0154L17.1542 30.0559L16.8489 30.079L16.2515 30.1307L15.9597 30.1591L15.3899 30.2209C14.923 30.2752 14.476 30.3359 14.05 30.4022L13.427 30.5057L12.8366 30.6167L12.3885 30.7104L11.9623 30.8079C11.7547 30.8576 11.5556 30.9086 11.3652 30.9607C11.3466 30.9657 11.3279 30.9681 11.3094 30.9681C11.2148 30.9681 11.1279 30.9035 11.102 30.8054C11.0717 30.6883 11.1396 30.5679 11.254 30.5367C11.5752 30.4489 11.9208 30.3641 12.2894 30.2834L12.7427 30.1886C12.8201 30.1732 12.8984 30.1579 12.9775 30.1428L13.4632 30.0547C14.1247 29.9404 14.842 29.8393 15.6097 29.7557L16.1949 29.6964L16.4944 29.6693L17.107 29.6205L17.42 29.599L18.0589 29.5617C19.4618 29.4898 20.9837 29.4755 22.6021 29.5373Z"
        fill="#003CE5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3511 28.857L24.8934 11.9881C25.0868 11.0639 26.2065 10.3865 27.1936 10.5431L35.3009 11.8302C36.288 11.9868 36.7688 12.9183 36.5749 13.8426L33.346 30.2239C33.1521 31.1482 32.1952 31.7705 31.208 31.6135L23.1007 30.3264C22.1141 30.1698 21.4706 29.2937 21.664 28.3694"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8248 27.2431L23.7914 9.88877C23.9728 8.89633 25.0859 8.18219 26.0775 8.36409L34.2215 9.85934C35.2131 10.0412 35.7077 11.0507 35.5258 12.0432L32.5105 29.6359C32.3287 30.6284 31.3779 31.2855 30.3862 31.1032L22.2422 29.6079C21.2511 29.4259 20.5943 28.474 20.7757 27.4816"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5223 10.8139C24.6765 9.97029 25.4848 9.41215 26.3276 9.56677L33.25 10.8377C34.0929 10.9923 34.6511 11.8015 34.4966 12.6451L31.5805 28.5884C31.4259 29.432 30.6178 29.9906 29.7748 29.8355L22.8524 28.5646C22.01 28.4099 21.4517 27.6008 21.6059 26.7572L24.5223 10.8139Z"
        fill="#8AE7F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0944 18.9238C31.1212 22.4321 34.6078 11.9527 34.4515 12.796L31.6725 28.5727C31.5161 29.416 30.7029 29.9752 29.8556 29.8212L22.8969 28.5583C22.05 28.4046 21.4896 27.5965 21.6455 26.7532C21.6455 26.7532 22.6114 21.5336 23.0944 18.9238Z"
        fill="#A2EBE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0168 18.7921C25.328 17.0935 26.9571 15.9686 28.6558 16.2802C30.3545 16.5914 31.4789 18.2205 31.1677 19.9192C30.8566 21.6179 29.227 22.7424 27.5287 22.4311C25.8305 22.1199 24.7055 20.4904 25.0168 18.7921Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2073 13.8514L28.4495 12.5309C28.5235 12.126 28.9122 11.8577 29.3172 11.9322L29.4039 11.9479C29.8089 12.0223 30.0771 12.4106 30.0031 12.8155L29.7609 14.136C29.6864 14.541 29.2982 14.8092 28.8933 14.7352L28.8061 14.7192C28.4011 14.6447 28.1333 14.2564 28.2073 13.8514Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9757 26.0297L26.2179 24.7092C26.2919 24.3039 26.6802 24.0361 27.0852 24.1106L27.1723 24.1262C27.5773 24.2006 27.8451 24.589 27.7711 24.9939L27.5289 26.3144C27.4548 26.7193 27.0666 26.9875 26.6616 26.9131L26.5744 26.8971C26.1694 26.823 25.9016 26.4347 25.9757 26.0297Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1045 25.7739L33.1517 12.5426C33.7564 11.8174 35.063 11.7449 35.861 12.3466L42.4151 17.2892C43.2132 17.8908 43.2004 18.9391 42.5952 19.6642L32.0538 32.6121C31.4486 33.3372 30.3115 33.4374 29.5136 32.8353L22.9595 27.8927C22.1619 27.2912 22.0051 26.2156 22.6098 25.4903"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7265 24.605L33.1642 10.1717C33.7903 9.38061 35.1084 9.27265 35.8985 9.89878L42.3873 15.0424C43.1774 15.6685 43.1402 16.792 42.5136 17.5829L31.592 31.7008C30.9655 32.4918 29.8175 32.6256 29.0275 31.999L22.5388 26.8554C21.7491 26.2294 21.6161 25.0806 22.2421 24.2894"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3154 24.0396L33.3754 11.3316C33.9076 10.6592 34.8833 10.5459 35.5549 11.0781L41.0703 15.4501C41.7419 15.9823 41.855 16.9589 41.3224 17.6312L31.2629 30.3392C30.7303 31.0116 29.7545 31.1253 29.083 30.5927L23.5676 26.2206C22.8964 25.6886 22.7833 24.712 23.3154 24.0396Z"
        fill="#8AE7F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3431 17.6461C33.7832 24.5121 41.7457 17.0719 41.2117 17.7432L31.3513 30.3684C30.8173 31.0397 29.8368 31.1516 29.161 30.6178L23.6097 26.2358C22.9341 25.7026 22.8186 24.7259 23.3522 24.0545C23.3522 24.0545 26.6914 19.7236 28.3431 17.6461Z"
        fill="#A2EBE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5757 23.0005C29.2224 21.9284 28.9941 19.9616 30.0662 18.6082C31.1385 17.2545 33.1049 17.0261 34.4586 18.0987C35.8123 19.1709 36.0403 21.1373 34.968 22.4911C33.8958 23.8448 31.9291 24.0726 30.5757 23.0005Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2027 15.7436L36.0364 14.6913C36.2919 14.3685 36.761 14.3141 37.0837 14.57L37.1529 14.6246C37.4755 14.8805 37.5301 15.3492 37.2746 15.672L36.4408 16.7242C36.1849 17.0468 35.7162 17.1014 35.3934 16.8459L35.324 16.7908C35.0013 16.5349 34.9472 16.0663 35.2027 15.7436Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5489 39.5203C41.9514 38.0178 37.4083 36.5753 31.4015 36.2986C25.3947 36.0217 20.1993 37.0154 19.7968 38.5179C19.394 40.0204 23.9371 41.4628 29.9439 41.7397C35.9507 42.0164 41.1461 41.0229 41.5489 39.5203Z"
        fill="#FFB4DE"
      />
      <rect
        x="17.1299"
        y="18.9662"
        width="27.0802"
        height="20.2789"
        rx="2.72908"
        fill="#CA4500"
      />
      <rect
        x="15.8401"
        y="18.9662"
        width="27.0802"
        height="20.2789"
        rx="2.72908"
        fill="#FF7800"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1596 25.9371H42.8844V32.2743H34.1596C32.2322 32.2743 30.6697 30.8557 30.6697 29.1057C30.6697 27.3558 32.2322 25.9371 34.1596 25.9371Z"
        fill="#FFA733"
      />
      <ellipse
        cx="33.8938"
        cy="29.1057"
        rx="1.9343"
        ry="1.90114"
        fill="#FFE39C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.1779 40.4562C44.1224 40.9534 44.8612 41.6783 45.1543 42.3957C45.1998 42.5074 45.1482 42.6358 45.0389 42.6826C45.0119 42.6941 44.9837 42.6996 44.9561 42.6996C44.872 42.6996 44.7924 42.6488 44.7579 42.5646C44.276 41.3851 42.2155 39.9228 39.5993 40.2387C39.4832 40.2538 39.3747 40.1673 39.3609 40.0469C39.3467 39.9265 39.431 39.8174 39.5486 39.8031C41.1513 39.6074 42.407 40.0508 43.1779 40.4562Z"
        fill="#003CE5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1242 40.0973C23.2414 40.1159 23.3216 40.2281 23.3031 40.3478C23.2847 40.4675 23.1747 40.5495 23.058 40.5307C22.0303 40.3665 21.0256 40.2441 20.049 40.1571L19.3218 40.0983C17.758 39.985 16.2714 39.9607 14.883 39.9978L14.2493 40.0191C14.0405 40.0276 13.834 40.0374 13.63 40.0485L13.0256 40.0855L12.4365 40.1293L11.8632 40.1794L11.3062 40.2352L10.7659 40.2961L10.2428 40.3614L9.49135 40.4664L9.0132 40.5402L8.55384 40.6163L8.11374 40.6942L7.69336 40.7732L7.29315 40.8527L6.73169 40.9716L6.21821 41.0882L5.61091 41.2367L5.09538 41.3727C5.0767 41.3777 5.05802 41.3801 5.03955 41.3801C4.94489 41.3801 4.85808 41.3155 4.83219 41.2174C4.80183 41.1003 4.86975 40.9799 4.98416 40.9487L5.48577 40.8157L6.03575 40.6791L6.63279 40.5409L7.27559 40.4033L7.96284 40.2684L8.56856 40.1597L9.33392 40.0354L10.0029 39.9385L10.558 39.8662L11.1303 39.7993L11.7195 39.7384L12.3251 39.6841L12.634 39.6596L13.2636 39.6164C16.1322 39.4402 19.4718 39.5135 23.1242 40.0973Z"
        fill="#003CE5"
      />
    </svg>
  );
};

export default HandWalletMoney;
